// src/routes/RoleRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function RoleRoute({ children, allow = [] }) {
  const location = useLocation();
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="h-6 w-6 border-2 border-gray-300 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // not logged in -> go login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const role = user?.role;

  // logged in but wrong role -> go login in "switch mode"
  if (allow.length > 0 && !allow.includes(role)) {
    return (
      <Navigate
        to="/login"
        state={{
          from: location,          // so after login it returns to /admin
          switchAccount: true,     // tell login page to NOT auto-redirect
          expectedRole: allow[0] || null,
        }}
        replace
      />
    );
  }

  return children;
}